var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgListAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 4C2.44772 4 2 4.44772 2 5V7C2 7.55228 2.44772 8 3 8H5C5.55228 8 6 7.55228 6 7V5C6 4.44772 5.55228 4 5 4H3Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 10C2.44772 10 2 10.4477 2 11V13C2 13.5523 2.44772 14 3 14H5C5.55228 14 6 13.5523 6 13V11C6 10.4477 5.55228 10 5 10H3Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 17C2 16.4477 2.44772 16 3 16H5C5.55228 16 6 16.4477 6 17V19C6 19.5523 5.55228 20 5 20H3C2.44772 20 2 19.5523 2 19V17Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 5.25C8.33579 5.25 8 5.58579 8 6C8 6.41421 8.33579 6.75 8.75 6.75H21.25C21.6642 6.75 22 6.41421 22 6C22 5.58579 21.6642 5.25 21.25 5.25H8.75Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8 12C8 11.5858 8.33579 11.25 8.75 11.25H21.25C21.6642 11.25 22 11.5858 22 12C22 12.4142 21.6642 12.75 21.25 12.75H8.75C8.33579 12.75 8 12.4142 8 12Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 17.25C8.33579 17.25 8 17.5858 8 18C8 18.4142 8.33579 18.75 8.75 18.75H21.25C21.6642 18.75 22 18.4142 22 18C22 17.5858 21.6642 17.25 21.25 17.25H8.75Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListAlt);
export default __webpack_public_path__ + "static/media/list-alt.e717491ccb00c3526920bd90d0094a5d.svg";
export { ForwardRef as ReactComponent };